export enum STORAGE_KEYS {
  ADMIN_AUTH = 'ADMIN_AUTH',
  AUTH = 'AUTH',
  ANALYTICS = 'analytics',
  PROJECTS = 'PROJECTS',
  SELECTED_PROJECT_ID = 'selectedProjectId',
  PUSH = 'push',
  IS_REMEMBERED_LOGIN = 'isRememberedLogin',
}
